import React, { Component } from 'react'

export default class Docs extends Component {

    render() {
        return (
    <div id="documentation-container">
            <div className="documentation-sidebar">
                <ol>
                    <li>
                        <a href="#doc-cli">Command-line Interface</a>
                    </li>
                    <li>
                        <a href="#doc-api-customization">API Customization</a>
                        <ol>
                            <li><a href="#doc-before-get">before_get</a></li>
                            <li><a href="#doc-after-get">after_get</a></li>
                            <li><a href="#doc-before-insert">before_insert</a></li>
                            <li><a href="#doc-after-insert">after_insert</a></li>
                            <li><a href="#doc-before-update">before_udpate</a></li>
                            <li><a href="#doc-after-update">after_update</a></li>
                            <li><a href="#doc-before-delete">before_delete</a></li>
                            <li><a href="#doc-after-delete">after_delete</a></li>
                            <li><a href="#doc-custom-get">custom_get</a></li>
                            <li><a href="#doc-custom-post">custom_post</a></li>
                            <li><a href="#doc-custom-delete">custom_delete</a></li>
                        </ol>
                    </li>
                </ol>
            </div>
            <div className="documentation">
                <h2 id="doc-cli">Command-line Interface</h2>
                <h3>Setup</h3>
                <p>Requires Python 3.</p>
                <p>Install with <code>$ pip install less.cli</code></p>
                <h3>Authentication</h3>
                <p>To authenticate use your less email/password with the following command:</p>
                <p><code>$ less login</code></p>
                <h3>List APIs</h3>
                <p><code>$ less api list</code></p>
                <h3>Update API's custom code</h3>
                <p><code>$ less api set-custom-code --name API_NAME --filename CODE_FILE</code></p>
                <h2 id="doc-api-customization">API Customization</h2>
                <p>You can modify the behavior of the API by supplying custom code 
                    to execute before and after the different API methods.</p>
                <p>Python is supported today. Support for additional languages is coming soon.</p>
                <h3>Methods</h3>
                <h4 id="doc-before-get">before_get</h4>
                <p>Executes before querying the underlying table.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table being queried.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>params (dict) - the query params as passed in the query string of the API method invocation.</li>
                    <li>access_token (dict) - Decoded <a href="#access-token-structure">access token</a> passed as a header to the current request. If the API does not have JWT authentication enabled - null. </li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed to access the underlying table, False - will cause an exception and will not proceed to accessing the table.</p>
                <h4 id="doc-after-get">after_get</h4>
                <p>Executes after querying the underlying table. You can modify the returned values here.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table being queried.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>result_set
                        <ul>
                            <li>If the query returned a single record (key was given as params) - 
                                a dict representing the returned record, keyed by attribute name.</li>
                            <li>If the query returned multuple records (key was not given) -
                                a list where each item is a dict representing a record.
                            </li>
                            <li>If no records are returned - None.</li>
                        </ul></li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed to respond with the values in result_set, False - causes an exception and responds with an error status.</p>
                <h4 id="doc-before-insert">before_insert</h4>
                <p>Executes before attempting to insert a new record into the underlying table.
                    You can modify the values here.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table being queried.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>values (dict) - values to insert, keyed by attribute name. Unrecognized attributes are ignored.</li>
                    <li>access_token (dict) - Decoded <a href="#access-token-structure">access token</a> passed as a header to the current request. If the API does not have JWT authentication enabled - null. </li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed with inserting into the underlying table, 
                    False - causes an exception and does not attempt to insert a new record into the underlying table.</p>
                <h4 id="doc-after-insert">after_insert</h4>
                <p>Executes after inserting a new record into the underlying table.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table being queried.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>values (dict) - values of the new record, keyed by attribute name.
                        Includes data that was generated by the insert process, such as auto-generated values.</li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed with responding with <strong>values</strong>, False - causes an exception and responds with an error status.</p>
                <h4 id="doc-before-update">before_update</h4>
                <p>Executes before attempting to update a record matching the given "key" in the underlying table.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table being queried.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>key - dict keyed by attribute name in the underlying table.
                    Must contain an item for each attribute in the primary key.</li>
                    <li>update_values - dict keyed on attribute name 
                    with the values to use to replace existing values in the updated record.</li>
                    <li>access_token (dict) - Decoded <a href="#access-token-structure">access token</a> passed as a header to the current request. If the API does not have JWT authentication enabled - null. </li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed with updating, False - causes an exception, does not perform the update and responds with an error code.</p>
                <h4 id="doc-after-update">after_update</h4>
                <p>Executes after updating a record in the underlying table.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table being queried.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>key - dict keyed by attribute name in the underlying table.
                    Must contain an item for each attribute in the primary key.</li>
                    <li>update_values - dict keyed on attribute name with the values used to update the record,
                    reflecting any changes during the update process.</li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed with responding with values, False - respond with an error status.</p>
                <h4 id="doc-before-delete">before_delete</h4>
                <p>Executes before attempting to delete a record matching the given key.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table from which to delete.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>params (dict) - the query params as passed in the query string of the API method invocation.</li>
                    <li>access_token (dict) - Decoded <a href="#access-token-structure">access token</a> passed as a header to the current request. If the API does not have JWT authentication enabled - null. </li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - proceed with deleting a record, False - prevents the delete and responds with an error status.</p>
                <h4 id="doc-after-delete">after_delete</h4>
                <p>Executes after deleting a record matching the given key from the underlying table.</p>
                <h5>Parameters</h5>
                <ol>
                <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table from which to delete.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>params (dict) - the query params as passed in the query string of the API method invocation.</li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - respond with a 200 status code, False - respond with an error status code.</p>


                <h4 id="doc-custom-get">custom_get</h4>
                <p>Use this function to support arbitrary GET handlers in your API.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>path (string) - the path of the HTTP GET request.</li>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table from which to delete.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>params (dict) - the query params as passed in the query string of the API method invocation.</li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - respond with a 200 status code, False - respond with an error status code.</p>

                <h4 id="doc-custom-post">custom_post</h4>
                <p>Use this function to support arbitrary POST handlers in your API.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>path (string) - the path of the HTTP POST request.</li>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table from which to delete.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>params (dict) - the query params as passed in the query string of the API method invocation.</li>
                    <li>values (dict) - body of the HTTP POST request as a dictionary.</li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - respond with a 200 status code, False - respond with an error status code.</p>

                <h4 id="doc-custom-delete">custom_delete</h4>
                <p>Use this function to support arbitrary DELETE handlers in your API.</p>
                <h5>Parameters</h5>
                <ol>
                    <li>path (string) - the path of the HTTP DELETE request.</li>
                    <li>table_config (dict) - <a href="#configuration-structure">configuration</a> of the table from which to delete.</li>
                    <li>orm (object) - <a href="#orm-object">ORM object</a> to access the underlying table.</li>
                    <li>params (dict) - the query params as passed in the query string of the API method invocation.</li>
                </ol>
                <h5>Return value</h5>
                <p>(bool) True - respond with a 200 status code, False - respond with an error status code.</p>


                <h3>Parameter structures</h3>
                <h4 id="configuration-structure">Table configuration structure</h4>
                <code><pre>
                    {JSON.stringify({
                        "name": "string",
                        "type": "string",
                        "attributes": [
                            {
                                "name": "string",
                                "type": "string",
                                "auto_generated": "bool",
                                "primary_key": "bool",
                                "required": "bool"
                            }
                        ],
                        "external": "bool",
                    }, null, 2)}
                </pre></code>
                <ul>
                    <li><strong>name</strong> - name of the table</li>
                    <li><strong>type</strong> - "dynamodb" or "postgres"</li>
                    <li><strong>attributes</strong> - attributes of the table</li>
                    <li><strong>external</strong> - true if this is a table in your existing database, false if this is table created on less</li>
                </ul>
                <h4 id="access-token-structure">Access token structure</h4>
                <p>Learn about <a href="https://jwt.io/">JSON Web Tokens</a>.</p>
                <code>
                    <pre>
                        {JSON.stringify({
                            "iss": "string",
                            "sub": "string",
                            "aud": ["string", "string", "..."],
                            "iat": "timestamp",
                            "exp": "timestamp"
                        }, null, 2)}
                    </pre>
                </code>
                <ul>
                    <li><strong>iss</strong> - issuer of the token</li>
                    <li><strong>sub</strong> - unique string identifier the authenticated user</li>
                    <li><strong>aud</strong> - list of audience values the current user is authorized for</li>
                    <li><strong>iat</strong> - issued at</li>
                    <li><strong>exp</strong> - expires at</li>
                </ul>
                <h4 id="orm-object">ORM object</h4>
                <p>Provides read/write access to an underlying data table</p>
                <h5>get_item(key)</h5>
                <p>Returns one dict representing the record in the underlying table with the given key or
                    None if not found.</p>
                <ul>
                    <li><strong>key</strong> - dict keyed by attribute name in the underlying table.
                    Must contain an item for each attribute in the primary key.</li>
                </ul>
                <h5>delete_item(key)</h5>
                <p>Deletes one record from the underlying table matching the given key.</p>
                <ul>
                    <li><strong>key</strong> - dict keyed by attribute name in the underlying table.
                    Must contain an item for each attribute in the primary key.</li>
                </ul>
                <h5>put_item(values)</h5>
                <p>Creates a record in the underlying table with the given attribute values.</p>
                <ul>
                    <li><strong>values</strong> - dict keyed by attribute name in the underlying table.
                    Must contain an item for each "required" attribute. Items with unrecognized keys are ignored.</li>
                </ul>
                <h5>update_item(key, values)</h5>
                <p>Updates an existing record in the underlying table.</p>
                <ul>
                    <li><strong>key</strong> - dict keyed by attribute name in the underlying table.
                    Must contain an item for each attribute in the primary key.</li>
                    <li><strong>values</strong> - dict of attributes to update keyed by attribute name.
                    Unrecognized attributes are ignored.</li>
                </ul>
            </div>
    </div>
        )
    }
}
